import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app/environment/environment';
import { buildBasicListRequestParams } from '@app/helpers/listQuery.helper';
import { LegalEntityAdmin } from '@app/models/admin.model';
import { FileInfo } from '@app/models/document.model';
import { LegalEntityRequest } from '@app/models/project-setup.models';
import { LegalEntity } from '@app/models/project.models';
import {
  ComplexPaginatedDataRequest,
  PaginatedData,
} from '@app/models/shared.models';
import { Observable } from 'rxjs';

export type ApprovalRequestId = string;
export type ApprovalRequestUpdate = Readonly<{ isApproved: boolean }>;
@Injectable({ providedIn: 'root' })
export class LegalEntityService {
  private readonly http = inject(HttpClient);
  private readonly API_URL = environment.apiUrl;

  getApprovableRequests(): Observable<any> {
    return this.http.get(`${this.API_URL}/LegalEntities/ApprovableRequests`);
  }

  getLegalEntitiesAdmin(
    params: ComplexPaginatedDataRequest = {},
  ): Observable<PaginatedData<LegalEntityAdmin>> {
    const requestParams = buildBasicListRequestParams(params);

    return this.http.get<PaginatedData<LegalEntityAdmin>>(
      `${this.API_URL}/LegalEntitiesAdmin`,
      { params: requestParams },
    );
  }

  getLegalEntityById(legalEntityId: string): Observable<any> {
    return this.http.get(`${this.API_URL}/LegalEntity/${legalEntityId}`);
  }

  updateLegalEntity(
    legalEntityId: string,
    payload: LegalEntityRequest,
  ): Observable<LegalEntity> {
    return this.http.put<LegalEntity>(
      `${this.API_URL}/LegalEntity/${legalEntityId}`,
      payload,
    );
  }

  getApprovalRequestsByLegalEntity(legalEntityId: string) {
    return this.http.get<any[]>(
      `${this.API_URL}/LegalEntity/${legalEntityId}/ApprovalRequests`,
    );
  }
  suspendLegalEntity(LegalEntityId: string): Observable<void> {
    return this.http.put<void>(
      `${this.API_URL}/LegalEntity/${LegalEntityId}/Suspend`,
      {},
    );
  }
  deSuspendLegalEntity(LegalEntityId: string): Observable<void> {
    return this.http.put<void>(
      `${this.API_URL}/LegalEntity/${LegalEntityId}/DeSuspend`,
      {},
    );
  }
  // TODO: header - export
  deleteLegalEntity(legalEntityId: string) {
    return this.http.delete(`${this.API_URL}/LegalEntity/${legalEntityId}`);
  }

  // legal entities - representatives
  getApprovalRequestFilesForEntity(
    legalEntityId: string,
  ): Observable<FileInfo[]> {
    const url = `${this.API_URL}/LegalEntity/${legalEntityId}/ApprovalRequest/Files`;
    return this.http.get<FileInfo[]>(url);
  }
  getApprovalRequestFiles(
    legalEntityId: string,
    userId: string,
  ): Observable<FileInfo[]> {
    const url = `${this.API_URL}/LegalEntity/${legalEntityId}/${userId}/ApprovalRequest/Files`;
    return this.http.get<FileInfo[]>(url);
  }

  updateApprovalRequest(
    approvalRequestId: ApprovalRequestId,
    isApproved: boolean,
  ): Observable<void> {
    const url = `${this.API_URL}/LegalEntities/ApprovalRequest/${approvalRequestId}`;
    const body: ApprovalRequestUpdate = { isApproved };
    return this.http.put<void>(url, body);
  }
  approveApprovalRequest(
    approvalRequestId: ApprovalRequestId,
  ): Observable<void> {
    return this.updateApprovalRequest(approvalRequestId, true);
  }
  rejectApprovalRequest(
    approvalRequestId: ApprovalRequestId,
  ): Observable<void> {
    return this.updateApprovalRequest(approvalRequestId, false);
  }
  // TODO: legal entities - delete - test it later
  deleteApprovalRequest(
    approvalRequestId: ApprovalRequestId,
  ): Observable<void> {
    return this.http.delete<void>(
      `${this.API_URL}/LegalEntities/ApprovalRequest/${approvalRequestId}`,
    );
  }

  getInvestors(): Observable<any> {
    return this.http.get<void>(
      `${this.API_URL}/LegalEntitiesProfAdmin?take=1000`,
    );
  }

  // TODO: header - export
  // TODO: header - delete
  // TODO: representatives - list
  // TODO: representatives - documents
  // TODO: representatives - approved / declined
  // TODO: representatives - delete

  // PC ZRT. CONTACTS - new api comes - change it
  // TODO: contact list
  // TODO: get contact by id
  // TODO: add new contact
  // details
  // TODO: header - reset password
  // TODO: header - suspend
  // TODO: header - delete
  // TODO: save contact
  // TODO: project list (+filter)
}
